import type { UserListFilterRole, UserListFilters } from "./UserListFilterRow";

/**
 * The user list's filters as URL query params, so a filtered list can be shared
 * or linked to (e.g. a camera's `?camera=<siteId>/<cameraKey>`). A type alias,
 * not an interface, so it satisfies Expo Router's indexed param types.
 */
export type UserListFilterParams = {
  readonly q?: string | undefined;
  readonly role?: string | undefined;
  readonly site?: string | undefined;
  readonly camera?: string | undefined;
};

const ROLES: readonly UserListFilterRole[] = [
  "tenant_admin",
  "site_manager",
  "site_viewer",
  "camera_manager",
  "camera_viewer",
];

const present = (value: string | undefined) => (value ? value : undefined);

export function userListFiltersFromParams(params: UserListFilterParams): UserListFilters {
  return {
    search: params.q ?? "",
    role: ROLES.find((role) => role === params.role) ?? null,
    siteId: present(params.site) ?? null,
    cameraId: present(params.camera) ?? null,
  };
}

/** Every key is always returned, so a cleared filter is removed from the URL. */
export function userListFiltersToParams(filters: UserListFilters): UserListFilterParams {
  return {
    q: present(filters.search),
    role: filters.role ?? undefined,
    site: filters.siteId ?? undefined,
    camera: filters.cameraId ?? undefined,
  };
}
